// @flow
function* ApiSaga() {}

export default ApiSaga
